<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'

interface Props {
  modelValue: string | number | null | undefined
  error?: boolean
  autofocus?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  error: false,
  autofocus: false,
})

defineEmits(['update:modelValue'])

const inputClass = computed(() => ({
  'border-neutral-300 dark:border-neutral-400': !props.error,
  'border-danger-300 dark:border-danger-400': props.error,
}))

const input = ref<HTMLInputElement | null>(null)

onMounted(() => (props.autofocus ? input.value?.focus() : null))

const focus = () => input.value?.focus()

defineExpose({
  focus,
})
</script>
<template>
  <input
    ref="input"
    class="px-3 py-2 bg-white border-1 dark:bg-neutral-600 dark:text-neutral-200 focus:border-primary-500 focus:ring-1 focus:ring-primary-200/50 rounded-md shadow-xs focus:outline-none"
    :class="inputClass"
    :value="modelValue"
    autocomplete="off"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>
